export const getDarkMode = state => state.darkModeReducer.darkMode;
